<template>
  <v-dialog
    v-model="rootStore.addEditdialog"
    max-width="500px"
    class="elevation-0"
    scrollable
    :persistent="rootStore.dialogLoading"
    overlay-opacity="0.6"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" class="text-capitalize" color="secondary" depressed rounded>
        Root Ekle
      </v-btn>
    </template>
    <v-card
      rounded="xl"
      flat
      :disabled="rootStore.dialogLoading"
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <h4 class="text-body-1 text-sm-h6 font-weight-bold">
          {{ rootStore.addEditFormTitle }}
        </h4>

        <v-spacer />

        <v-btn
          color="error"
          small
          outlined
          class="mx-4 text-capitalize"
          rounded
          v-if="rootStore.editedIndex > -1"
          :loading="rootStore.deleteLoading"
          @click="rootStore.deleteItem()"
        >
          <v-icon left>{{ icons.mdiTrashCan }}</v-icon> Sil
        </v-btn>
        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          rounded
          small
          depressed
          color="chip"
          class="text-capitalize"
          @click="rootStore.closeItem"
        >
          <v-icon left>{{ icons.mdiClose }}</v-icon>
          Kapat
        </v-btn>
        <v-icon v-else small @click="rootStore.closeItem">{{ icons.mdiClose }}</v-icon>
      </v-card-title>

      <v-divider />
      <v-card-text
        ref="scrollableEl"
        class="pa-0 pa-sm-3 pb-0 pt-3"
        style="height: 80dvh"
        :style="!$vuetify.breakpoint.smAndUp ? 'max-height: 485px' : 'max-height: 500px'"
      >
        <validation-observer ref="form">
          <v-container class="pb-0">
            <v-row v-if="false">
              <v-col>
                <pre>{{ rootStore.editedItem }}</pre>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-text-field
                    v-model="rootStore.editedItem.rootno"
                    label="Root No"
                    rounded
                    filled
                    hide-details
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-select
                    v-model="rootStore.editedItem.orderdays"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :items="dayItems"
                    label="Sipariş Günleri"
                    :error-messages="errors"
                    multiple
                    rounded
                    filled
                    hide-details
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-select
                    v-model="rootStore.editedItem.mattype"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :items="[
                      { text: '*', value: '*' },
                      { text: 'SARF', value: 'SARF' },
                      { text: 'MAMUL', value: 'MAMUL' },
                      { text: 'TAZE', value: 'TAZE' },
                    ]"
                    label="Sipariş Tipi"
                    :error-messages="errors"
                    rounded
                    filled
                    hide-details
                  />
                </validation-provider>
              </v-col>
              <v-col cols="6">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-text-field
                    v-model="rootStore.editedItem.orderdelivery"
                    filled
                    label="Sipariş Teslimat"
                    rounded
                    hide-details
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="6">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-text-field
                    v-model="rootStore.editedItem.addorderdelivery"
                    filled
                    label="Ek Sipariş Teslimat"
                    rounded
                    hide-details
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="6">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-select
                    v-model="rootStore.editedItem.openhour"
                    filled
                    label="Açılış Saati"
                    rounded
                    hide-details
                    :items="clockItems"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="6">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-select
                    v-model="rootStore.editedItem.closehour"
                    filled
                    label="Kapanış Saati"
                    rounded
                    hide-details
                    :items="clockItems"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="6">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-select
                    v-model="rootStore.editedItem.addopenhour"
                    filled
                    label="Ek Açılış Saati"
                    rounded
                    hide-details
                    :items="clockItems"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="6">
                <validation-provider v-slot="{ errors }" tag="div" mode="eager" rules="required">
                  <v-select
                    v-model="rootStore.editedItem.addclosehour"
                    filled
                    label="Ek Kapanış Saati"
                    rounded
                    hide-details
                    :items="clockItems"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>

              <v-col v-if="!$vuetify.breakpoint.smAndUp">
                <v-switch
                  v-model="rootStore.editedItem.isactive"
                  class="mt-0 pt-0 ml-3"
                  inset
                  color="secondary"
                  :label="rootStore.editedItem.isactive ? 'Aktif' : 'Pasif'"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </validation-observer>
      </v-card-text>
      <v-card-actions class="pa-0 pa-sm-3 pt-0">
        <v-container class="pt-0" style="z-index: 2">
          <v-row align="center">
            <v-col cols="12" :sm="rootStore.editedIndex > -1 ? 7 : 12">
              <v-btn
                color="secondary"
                depressed
                rounded
                block
                x-large
                :loading="rootStore.saveLoading"
                class="text-capitalize"
                @click="saveItem()"
              >
                {{ rootStore.editedIndex > -1 ? "Güncelle" : "Kaydet" }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="5"
              v-if="rootStore.editedIndex > -1 && $vuetify.breakpoint.smAndUp"
            >
              <v-switch
                v-model="rootStore.editedItem.isactive"
                hide-details
                class="mt-0 pt-0 ml-3"
                inset
                color="secondary"
                :label="rootStore.editedItem.isactive ? 'Aktif' : 'Pasif'"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch, toRefs, onMounted } from "vue-demi";

// Pinia
import { useRootStore } from "./_store";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";

// Icons
import { mdiClose, mdiTrashCan, mdiEye, mdiEyeOff } from "@mdi/js";

export default {
  setup() {
    // Pinia
    const rootStore = useRootStore();

    const scrollableEl = ref(null);

    // Kaydırma çubuğu
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);
    onMounted(() => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const clockItems = [
      "00:00",
      "00:30",
      "01:00",
      "01:30",
      "02:00",
      "02:30",
      "03:00",
      "03:30",
      "04:00",
      "04:30",
      "05:00",
      "05:30",
      "06:00",
      "06:30",
      "07:00",
      "07:30",
      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",
      "21:00",
      "21:30",
      "22:00",
      "22:30",
      "23:00",
      "23:59",
    ];
    const dayItems = [
      {
        text: "Pazar",
        value: 0,
      },

      {
        text: "Pazartesi",
        value: 1,
      },
      {
        text: "Salı",
        value: 2,
      },
      {
        text: "Çarşamba",
        value: 3,
      },
      {
        text: "Perşembe",
        value: 4,
      },
      {
        text: "Cuma",
        value: 5,
      },
      {
        text: "Cumartesi",
        value: 6,
      },
    ];

    const form = ref(null);
    const saveItem = async () => {
      const isValid = await form.value.validate();

      rootStore.saveItem(isValid);
    };
    const showPassword = ref(false);

    watch(
      () => rootStore.addEditdialog,
      (val) => {
        if (!val) {
          form.value.reset();
        } else {
        }
      }
    );

    return {
      rootStore,
      scrollableEl,
      form,
      dayItems,
      clockItems,
      saveItem,
      showPassword,
      isScroll,
      arrivedState,
      // icons
      icons: {
        mdiClose,
        mdiTrashCan,
        mdiEye,
        mdiEyeOff,
      },
    };
  },
};
</script>
